import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { IScreenType } from './helpers/typings';
import OptionCard from './OptionCard';

type ScreenCardProps = {
    screen: IScreenType;
    onScreenEdit: () => void;
    screenSelector: (screen: IScreenType) => void;
    deleteScreen: () => void;
};

const ScreenCard: React.FC<ScreenCardProps> = ({
    screen,
    onScreenEdit,
    screenSelector,
    deleteScreen,
}) => {
    const [showOpt, setShowOpt] = useState(false);
    return (
        <Card className="mb-3">
            <Card.Body>
                <Card.Title className="mb-2">
                    Screen (Rank: {'rank' in screen ? screen.rank : 'N/A'})
                </Card.Title>

                <p className="mb-2">
                    <strong>Screen Type:</strong> {screen.type}
                </p>
                <p className="mb-2">
                    <strong>Description:</strong> {screen.description || 'N/A'}
                </p>
                {screen.type === 'question' && (
                    <>
                        <p className="mb-2">
                            <strong>Header:</strong> {screen.header || 'N/A'}
                        </p>
                        <p className="mb-2">
                            <strong>Mandatory:</strong>{' '}
                            {screen.ismandatory ? 'Yes' : 'No'}
                        </p>
                        <p className="mb-2">
                            <strong>Image:</strong>{' '}
                            {screen.image ? (
                                <a
                                    href={screen.image}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {screen.image}
                                </a>
                            ) : (
                                <span>N/A</span>
                            )}
                        </p>
                        <p className="mb-2">
                            <strong>Activity Time:</strong>{' '}
                            {screen.activityTime
                                ? `${screen.activityTime}s`
                                : 'N/A'}
                        </p>
                    </>
                )}
                <>
                    <div className="mb-2 d-flex gap-2">
                        {screen.type === 'question' &&
                            screen.options.length > 0 && (
                                <Button onClick={() => setShowOpt(!showOpt)}>
                                    {showOpt ? 'Hide Options' : 'Show Options'}
                                </Button>
                            )}
                        {/* <Button>Add Option</Button> */}
                        <Button
                            onClick={() => {
                                screenSelector(screen);
                                onScreenEdit();
                            }}
                        >
                            Edit Screen
                        </Button>
                        <Button
                            variant="danger"
                            onClick={() => {
                                const cnf = window.confirm(
                                    'Are you sure you want to delete this screen?',
                                );
                                if (cnf) {
                                    // deleteScreen(screen.id);
                                    deleteScreen();
                                }
                            }}
                        >
                            Delete Screen
                        </Button>
                    </div>
                    {screen.type === 'question' &&
                        showOpt &&
                        screen.options.map(opt => (
                            <OptionCard key={opt.id} option={opt} />
                        ))}
                </>
            </Card.Body>
        </Card>
    );
};

export default ScreenCard;
